import { get } from '@/utils/fetch';
import type { FetchResponse } from '@/utils/fetch';

/**
 * 支付狀態查詢
 * @param billId
 * @returns
 */
export const isPaySuccess = (billId: string) =>
  get<FetchResponse<boolean>>('/payment/bill/success', { billId });

/**
 * 獲取身份識別地址
 * @param data
 * @returns
 */
export const getFirstFaceUrl = (data) => get<FetchResponse<string>>('/identities/auth-url', data);
